import { Directive } from '@angular/core';

@Directive({
  selector: '[puiButtonDropDown]'
})
export class PuiButtonDropDownDirective {}
